import React, { useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { analySend, getInfo } from '@chat/utils';
import useObjectState from '@/hooks/useObjectState';
import { getreason } from '@/redux/faq/action';
import { IM_CTX, IM_MESSAGE, IM_REASON } from '@/typings/global';
import { MyThunkResult } from '@/typings/reducer';
import { outline } from '@/helpers/online';

const turnObj = (reasons: IM_REASON[]) => {
    const obj = {};
    reasons.forEach((item) => {
        obj[item.id] = false;
    });
    return obj;
};
function Reason({ ctx, id }: Partial<IM_MESSAGE>): JSX.Element {
    const reason_ctx = ctx as IM_CTX;
    const { u, v } = getInfo();
    const dispatch: MyThunkResult<Promise<any>, any> = useDispatch();
    const { can_faq, un_solve_reason, platform, game_key, game_name, faq_unique_id, request_type } =
        useSelector(
            ({ FaqReducer, IndexReducer }) => ({
                can_faq: FaqReducer.can_faq,
                un_solve_reason: FaqReducer.un_solve_reason,
                request_type: FaqReducer.request_type,
                platform: IndexReducer.base_config.game.platform,
                game_key: IndexReducer.base_config.game.key,
                game_name: IndexReducer.base_config.game.name,
                faq_unique_id: IndexReducer.base_config.faq_unique_id
            }),
            shallowEqual
        );
    const { objState: status, handleObjState: setStatus } = useObjectState({
        initialValue: turnObj(un_solve_reason)
    });
    const [isClick, setClick] = useState(false);
    // 禁用相关样式
    // 按钮能否被点击
    const _handleShouldClick = (name: number) => {
        return classnames(`btn-${name}`, {
            'disable-reason-btn': !can_faq || isClick,
            cur: status[name],
            siblings: !status[name]
        });
    };
    const _handleClickReason = async (name, item: IM_REASON) => {
        if (outline()) return;
        setStatus(name, true);
        setClick(true);
        try {
            await dispatch(
                getreason({ log_id: reason_ctx.log_id, reason_id: item.id, dify: reason_ctx.dify })
            );
        } catch (error) {
            setStatus(name, false);
            setClick(false);
        } finally {
            analySend('element_click', {
                page_name: '咨询页',
                element_name: item.reason,
                project_id: platform,
                game_key,
                game_name,
                uid: u,
                vid: v,
                ai_session_id: faq_unique_id,
                ai_message_id: id,
                session_type: request_type,
                answer_source: reason_ctx.dify === 1 ? 'AI' : '关键词匹配'
            });
        }
    };
    return (
        <div className="im-faq-reason">
            <span>可以告诉小助手哪里做的不好嘛？小助手会根据您的问题召唤人工客服为您服务哦～</span>
            <div
                className={classnames('im-reason-btn', {
                    'disable-reason': isClick || !can_faq
                })}
            >
                {un_solve_reason.map((item, index) => (
                    <button
                        key={`reason${index + 1}`}
                        className={_handleShouldClick(item.id)}
                        onClick={() => _handleClickReason(item.id, item)}
                    >
                        {item.reason}
                    </button>
                ))}
            </div>
        </div>
    );
}

export default Reason;
